import React from 'react';
import { SettingsContainer } from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import { WorkingDaysSettingsSpa } from '@atlassian/jira-software-board-settings-working-days';

export const LazyWorkingDaysSettingsSpa = () => (
	<SettingsContainer packageId="jira-board-settings.working-days-settings-route">
		<WorkingDaysSettingsSpa />
	</SettingsContainer>
);

export default LazyWorkingDaysSettingsSpa;
